import { sendRequest } from '../../config';
import { normalizeDateFields } from '../../../../api/utils/responseNormalizer';

export interface addLocalizadorParams {
    typeService: string;
    cproducto: string;
    cpais: string;
    cciaseg: string;
    ccliente: string;
    cplan: string; // idPlan
    icita: string;
    tlocaliza: string;
    imotivo: string;
    cdiagnos: string;
    ctrata: string;
    itipodoctit: string;
    ccedtitu: string;
    xtitular: string;
    xtitular_ap: string;
    fnacimi_t: string;
    ctipoasistencia: string;
    isexo_t: string;
    itipoaseg: string;
    isexo: string;
    ccedaseg: string;
    xnombre: string;
    xapellido: string;
    fnacimiento: string;
    xcel: string;
    xtelefonocel: string;
    xemail: string;
    itipodocben: string;
    fcita: string;
    fhora: string;
    cdoctor?: string;
    cclinica?: string;
    iestado: string;
    cprocedencia: string;
    xdescripcion: string;
    creaclave: boolean;
}

export interface dataAddLocalizador {
    description?: string;
    level?: string;
    log?: string;
    tope?: string;
    topes?: any;
    cusuariogp?: string;
    mensaje?: string;
    updatewscita?: any;
    attachments?: string;
    wsencuestas?: string;
    WSCALENDARSD?: string;
    vOutputWS?: any;
    wscontratos?: any;
    maaliados?: string;
    wscnxincli_email?: any;
    wscnxincli_sms?: any;
    wsclaves?: string;
    bancosDatos?: string;
    qareembolso?: string;
    cpais?: string;
    ccita?: string;
    nlocaliza?: string;
    iestado?: string;
    xcorreoaliado?: string;
    xcorreoaliado2?: string;
    localizador?: any;
}

const DATE_FIELDS = [
    'fcita', 'fnacimiento', 'fnacimi_t', 'fcontacto', 'fultmod',
    'fingreso', 'fdesde_pol', 'fhasta_pol', 'fencursod', 'fencursoh',
    'faprobado', 'frechazado', 'ffactura', 'fcierre',
    'fdesde_pol_org', 'fhasta_pol_org', 'fencursod_org', 'fencursoh_org',
    'fagenda',
];

export const addLocalizador = async (params: addLocalizadorParams): Promise<dataAddLocalizador> => {

    const ENDPOINT = 'v2/localizador/add';
    const response = await sendRequest<dataAddLocalizador>({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
    return normalizeDateFields(response, DATE_FIELDS);
};